"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { Button, Stack, Text } from "@leabankab/component-library";
import { StepContainer } from "@/components/layout";
import { Heading, StepPanel } from "@/components/ui";
import { ProcessType } from "@/types";

interface Props {
	flowId: string;
	orderId: string;
	processType: ProcessType;
}

const MockSignScreen = ({ flowId, orderId, processType }: Props) => {
	const t = useTranslations("pages.MockSignPage");
	const router = useRouter();
	const [loading, setLoading] = useState(false);

	const handleComplete = async () => {
		setLoading(true);
		try {
			const response = await fetch("/api/mockServer/completeSign", {
				method: "POST",
			});
			if (!response.ok) {
				throw new Error("Failed to complete mock sign");
			}
			router.push(`/${flowId}`);
		} catch (error) {
			console.error(error);
			setLoading(false);
		}
	};

	const nextStepLabel =
		processType === ProcessType.CardSE ? t("nextWallet") : t("nextApproved");

	return (
		<StepContainer gap={2.5}>
			<Stack gap={0.5}>
				<Heading level={1} textStyle="heading-md">
					{t("title")}
				</Heading>
				<Text color="text.subtle">{t("description")}</Text>
			</Stack>

			<StepPanel variant="subtle" className="px-3 py-2">
				<Text color="text.subtle">{t("orderId", { orderId })}</Text>
				<Text color="text.subtle">{nextStepLabel}</Text>
			</StepPanel>

			<Button onClick={() => void handleComplete()} disabled={loading}>
				{t("complete")}
			</Button>
		</StepContainer>
	);
};

export default MockSignScreen;
